import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';

import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';

function FilterDropdown({ dropdown, setDropdown, children }) {
	const { t } = useTranslation()

	const dropdownRef = useRef(null);
	useOutsideAlerter(dropdownRef);


	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setDropdown(false)
				}
			}
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}


	return (
		<>
			<button className="white third" onClick={() => setDropdown(true)} ref={dropdownRef}>
				<FilterIcon />
				{t('filters')}

				<div className={`filter-dropdown ${dropdown ? 'show' : ''}`}>
					<div className="menu">
						{children}
					</div>
				</div>
			</button>

		</>
	)
}

export default FilterDropdown